import { render, staticRenderFns } from "./artefact-layer.vue?vue&type=template&id=f8e8fa58&scoped=true&"
import script from "./artefact-layer.vue?vue&type=script&lang=ts&"
export * from "./artefact-layer.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-layer.vue?vue&type=style&index=0&id=f8e8fa58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e8fa58",
  null
  
)

export default component.exports